/* eslint-disabled */
import QuestionCondition from "./QuestionCondition";
import Question from "./Question";
import QuestionConditionGroupExtend from "@/entity/extends/QuestionConditionGroupExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class QuestionConditionGroup extends QuestionConditionGroupExtend {

public id!: number;
public conditions: Array<QuestionCondition> = [];
public question!: Question;

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       hydrateCollection(object.conditions, QuestionCondition, this.conditions);
this.question = (object.question instanceof Question) ? object.question : new Question(object.question);
      }
      this.postConstruct()
  }

}
